import { FC, useCallback } from 'react';
import { css } from '@emotion/react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { PersonsV3 } from '@frontend/api-person';
import { IconName } from '@frontend/icons';
import { Avatar, PopoverDialog, usePopoverDialog } from '@frontend/design-system';
import { TaskFormRow, PaginatedSearchableList } from '../../common';

interface PatientPickerProps {
  label: string;
  icon: IconName;
  buttonIconName: IconName;
  placeholder: string;
  onChange: (value: Person | null) => void;
  value: Person | null;
  isEditing?: boolean;
  isRemoveable?: boolean;
  trackingIds?: {
    removeButton?: string;
    chipButton?: string;
  };
}

export const PatientPicker: FC<PatientPickerProps> = ({
  label,
  icon,
  buttonIconName,
  placeholder,
  onChange,
  value,
  isEditing,
  isRemoveable,
  trackingIds,
}) => {
  const { getDialogProps, getTriggerProps, close } = usePopoverDialog({ placement: 'bottom-start' });

  const name = value ? PersonsV3.PersonHelpers.getFullName(value) : '';
  const LeftElement = value ? <Avatar name={name} isUser size='xs' /> : null;

  const onSelect = useCallback(
    (person: Person) => {
      onChange(person);
      close();
    },
    [onChange]
  );

  return (
    <TaskFormRow
      label={label}
      icon={icon}
      placeholder={placeholder}
      buttonIconName={buttonIconName}
      value={name}
      getTriggerProps={getTriggerProps}
      isEditing={isEditing}
      isRemoveable={isRemoveable}
      trackingIds={trackingIds}
      onClickRemove={() => onChange(null)}
      leftElement={LeftElement}
    >
      <PopoverDialog
        {...getDialogProps()}
        css={css`
          width: 300px;
          height: 275px;
          overflow: hidden;
        `}
      >
        <PaginatedSearchableList onSelect={onSelect} selectedPatient={value} />
      </PopoverDialog>
    </TaskFormRow>
  );
};
